module.exports = __webpack_public_path__ + "fromGroomToMother-we-w.a65aa7f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToMother-we-w.jpg
// module id = Lb58
// module chunks = 0